<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SETTINGS_LICENSE_GENERATION' }
  ]"
></breadcrumbs>

<page-header title="SETTINGS_LICENSE_GENERATION"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="RDN_FOLDER_LAYER">{{
        'RDN_FOLDER_LAYER' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="activeLayers"
          name="SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER"
          [multiple]="false"
          [closeOnSelect]="true"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER')
          }"
          bindLabel="name"
          bindValue="id"
          [ngModel]="getField(['SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER'])"
          (change)="
            handleFieldChange(
              $event?.id,
              'SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER'
            )
          "
          [ngModelOptions]="{ standalone: true }"
          class="is-small"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER')"
      >
        {{ getError('SETTINGS_LICENSE_GENERATION_RDN_PATH_LAYER') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="BUSINESS_LICENSE_FOLDER_LAYER"
        >{{ 'BUSINESS_LICENSE_FOLDER_LAYER' | translate }}</label
      >
      <div class="control">
        <ng-select
          [items]="activeLayers"
          name="SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER"
          [multiple]="false"
          [closeOnSelect]="true"
          [ngClass]="{
            'is-danger': hasError(
              'SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER'
            )
          }"
          bindLabel="name"
          bindValue="id"
          [ngModel]="
            getField(['SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER'])
          "
          (change)="
            handleFieldChange(
              $event?.id,
              'SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER'
            )
          "
          [ngModelOptions]="{ standalone: true }"
          class="is-small"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER')"
      >
        {{ getError('SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER"
        >{{
          'SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER' | translate
        }}</label
      >
      <div class="control">
        <ng-select
          [items]="activeLayers"
          name="SETTINGS_LICENSE_GENERATION_BUSINESS_PATH_LAYER"
          [multiple]="false"
          [closeOnSelect]="true"
          [ngClass]="{
            'is-danger': hasError(
              'SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER'
            )
          }"
          bindLabel="name"
          bindValue="id"
          [ngModel]="
            getField(['SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER'])
          "
          (change)="
            handleFieldChange(
              $event?.id,
              'SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER'
            )
          "
          [ngModelOptions]="{ standalone: true }"
          class="is-small"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER')"
      >
        {{ getError('SETTINGS_LICENSE_GENERATION_COMPOUNDS_PATH_LAYER') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
